import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../shared/services/http.service';
import { HelperService } from '../shared/services/helper.service';


@Injectable()
export class AuthService {

  //private AUTHENTICATION_ENDPOINT: string = '/connect/token';
  private BASE_URL: string = HelperService.buildRequestURL(environment.STSSettings.stsAuthority);
  //private REQUEST_URL: string = `${this.BASE_URL}${this.AUTHENTICATION_ENDPOINT}`;
  private REQUEST_URL: string = `${this.BASE_URL}`;
  private URL: string;

  constructor(private http: HttpClient,
             private httpService: HttpService) { }

  // public GetAuthTokenAsync(username : string, password : string): Promise<any> {
  //     const dataForBody = `${'client_id=apiconnect&'}${'grant_type=password&' + 'client_secret=71D58FDC-8467-4D61-9010-DCE401F16A78' + 'username='+username +'&' + 'password='+ password +'&' + 'scope=securityapi'}`;
  //     const httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/x-www-form-urlencoded'
  //       })
  //     };
  //     let tokenNew = this.httpService.postAsync(this.REQUEST_URL, dataForBody, httpOptions)
  //     return tokenNew;
  // }

  public GetAuthTokenAsync(username : string, password : string) {
    //debugger;
    const dataForBody = `${'client_id=apiconnect&'}${'grant_type=password&' + 'client_secret=71D58FDC-8467-4D61-9010-DCE401F16A78&' + 'username='+username +'&' + 'password='+ password +'&' + 'scope=securityapi'}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    let tokenNew = this.httpService.post(this.REQUEST_URL, dataForBody, httpOptions)
    return tokenNew;
  }

  public logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem('UserLoginId');
    window.location.reload()
    //this.router.navigate(['login']); 
  }

  public setCurrentUser(username: string){
    localStorage.setItem('UserLoginId', username);
  }

  public getCurrentUser() :string{
    return localStorage.getItem('UserLoginId');
  }  
}



